import { createContext } from 'react';
import { createTranslator, type Language, type Translator } from './messages';

export interface LanguageContextValue extends Translator {
  language: Language;
  locale: 'en-US' | 'ja-JP';
  setLanguage: (language: Language) => void;
  preferenceUnavailable: boolean;
}

export const LanguageContext = createContext<LanguageContextValue>({
  ...createTranslator('en'),
  language: 'en',
  locale: 'en-US',
  setLanguage: () => {
    throw new Error('Language switching requires LanguageProvider');
  },
  preferenceUnavailable: false,
});
